import {AppLayout} from "../AppLayout";
import {ErrorMessageView} from "../base/ErrorMessageView";

export interface Props {
    header: string;
}

export const ErrorPage: React.FC<Props> = ({header}) => {
    return (
        <AppLayout>
            <ErrorMessageView message={header} />
        </AppLayout>
    );
};
